<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<div class="cross">
<p class="body"><br/></p>
<h1 class="part-number---IVP" title="Part 2: Cruciformation: Worship in the Way of the Cross"><span class="text_color">Part 2</span></h1>
<h2 class="part-title---IVP sigil_not_in_toc" id="_idParaDest-8" title="Cruciformation: Worship in the Way of the Cross"><a id="_idTextAnchor072"></a><br/><br/><span class="large">Cruciformation</span></h2>
<h3 class="part-sub sigil_not_in_toc">Worship in the Way of the Cross</h3>
<p class="body" lang="en-US" xml:lang="en-US"><span epub:type="pagebreak" id="page32" title="32"></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2.vue?5c7502c0